import { TableColumn } from '../types/column'
import { TableData } from '../types/data'

// Same id the table assigns in getColumns: an explicit id wins, otherwise a string accessor.
// A function accessor without an id has no stable id, so it is left out.
export const getColumnsIds = <T extends TableData>(columns: TableColumn<T>[]): string[] =>
  columns.flatMap(({ id, accessor }) => {
    if (id) {
      return [id]
    }
    return typeof accessor === 'string' ? [accessor] : []
  })
